import { render, staticRenderFns } from "./keys.vue?vue&type=template&id=c52413c2&scoped=true"
import script from "./keys.vue?vue&type=script&lang=js"
export * from "./keys.vue?vue&type=script&lang=js"
import style0 from "./keys.vue?vue&type=style&index=0&id=c52413c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52413c2",
  null
  
)

export default component.exports